import React from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import Services from './Services';
import Blogs from './Blogs';
import Contact from './Contact';
import Footer from './Footer';

const Home = () => {
  return (
    <>
      <Navigation />
      <Hero />
      <Services />
      <Blogs />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;




